<template>
	<div class="ModuleBox" v-if="Visible">
		<div class="ModuleBoxBody">
			<div class="ModuleBoxBodyTop">
				<div class="ModuleBoxBodyTopTitle">{{Title}}</div>
				<div class="ModuleBoxBodyTopCloseBtn" @click="onHide()">
					<el-icon><Close /></el-icon>
				</div>
			</div>
			<div class="ModuleBoxBodyBody">
				<div class="ModuleBoxBodyBodyRule">
					<div class="ModuleBoxBodyBodyRuleTop">
						<div class="ModuleBoxBodyBodyRuleTopTitle">兑换规则</div>
					</div>
					<div class="ModuleBoxBodyBodyRuleBody">
						<el-scrollbar>
							<div class="ModuleBoxBodyBodyRuleBodyText" v-html="ExchangeData[0].ExchangeRuleText"></div>
						</el-scrollbar>
					</div>
				</div>
				<div class="ModuleBoxBodyBodyQRCode">
					<div class="ModuleBoxBodyBodyQRCodeImage">
						<el-image :src="ExchangeData[0].CustomerServiceQRCode" fit="cover" />
					</div>
					<div class="ModuleBoxBodyBodyQRCodeTitle">客服二维码</div>
					<div class="ModuleBoxBodyBodyQRCodeElement1">
						<el-image :src="IntroduceBackgroundElementUrl" fit="scale-down" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
